import { makeStyles, Typography } from "@material-ui/core"
import { FC } from "react"
import { colors } from "../../utils/theme"
import { MoodBarDataProps, MoodIconProps } from "../../utils/types"
import CircleIcon from "../atoms/CircleIcon"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"
import { getReportedMoodDays } from "../../utils/moodChart"
import dayjs from "dayjs"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  title: {
    color: colors.neutral.white,
    fontWeight: 700,
    marginBottom: 4,
  },
  subtitle: {
    color: colors.neutral.white,
    fontWeight: 400,
    marginBottom: 12,
  },
  item: {},
  itemMargin: {
    marginBottom: 12,
  },
  iconTitleContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 4,
  },
  itemIcon: {
    marginRight: 8,
    height: 16,
  },
  itemTitle: {
    color: colors.neutral.white,
    fontWeight: 700,
  },
  itemText: {
    color: colors.neutral.white,
    fontWeight: 400,
    marginLeft: 24,
  },
})

enum TIME_PERIOD {
  WEEK = "week",
  MONTH = "month",
}

interface ItemProps {
  Icon: FC<MoodIconProps>
  backgroundColor: string
  title: string
  text: string
}

const Item: FC<ItemProps> = ({ Icon, title, text, backgroundColor }) => {
  const classes = useStyles()
  return (
    <div className={classes.item}>
      <div className={classes.iconTitleContainer}>
        <div className={classes.itemIcon}>
          <Icon backgroundColor={backgroundColor} height={16} width={16} />
        </div>
        <Typography variant="body1" className={classes.itemTitle}>
          {title}:
        </Typography>
      </div>
      <Typography variant="body1" className={classes.itemText}>
        {text}
      </Typography>
    </div>
  )
}

const MoodHelpIcon: FC<MoodBarDataProps> = ({ data = [], timePeriod }) => {
  const classes = useStyles()

  const chartData = getReportedMoodDays(
    dayjs(),
    timePeriod === TIME_PERIOD.WEEK ? 7 : 30,
    data
  )

  const showGrowth =
    chartData.filter(
      (data) => data.growth !== undefined && data.growth !== null
    ).length > 0

  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle1" className={classes.title}>
            Mood
          </Typography>
          <Typography variant="body1" className={classes.subtitle}>
            This chart displays your client’s mood balance
          </Typography>
          <Item
            Icon={CircleIcon}
            backgroundColor={colors.tertiary.orange}
            title="Enjoyment"
            text="When your client experiences fun, joy, or happiness."
          />
          {showGrowth && (
            <Item
              Icon={CircleIcon}
              backgroundColor={colors.primary.periwinkle}
              title="Growth"
              text="When your client feels integrity, purpose, or accomplishment."
            />
          )}
        </>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default MoodHelpIcon
